import React, { useState } from 'react'
import styled from 'styled-components'
import { Box, Collapse } from '@material-ui/core'
import { useHistory, useLocation } from 'react-router'

// import Topback from 'assets/images/layout/topbar/back.png'
import LogoWithText from 'assets/images/layout/topbar/logowithtext.png'
import Social1 from 'assets/images/social/twitter.svg'
import Social2 from 'assets/images/social/telegram.svg'
import Social3 from 'assets/images/social/reddit.svg'
import Social4 from 'assets/images/social/medium.svg'

interface Props {
    refs: any
}

const Topbar: React.FC<Props> = ({ refs }) => {
    const [open, setOpen] = useState(false)
    const [secIndex, setSecIndex] = useState(0)
    const location = useLocation()
    const history = useHistory()
    const handleNavigate = (id: number) => {
        setSecIndex(id)
        if (id === 3)
            window.open('https://docs.frozen.exchange/', '_blank')
        else if (location.pathname !== '/presale')
            refs[id].current.scrollIntoView({ behavior: 'smooth' });
        else
            history.push('/')
    }
    return (
        <StyledContainer>
            <Box display='flex' onClick={() => history.push('/')}>
                <img src={LogoWithText} alt='' />
            </Box>
            <Box display='flex' alignItems='center'>
                <PCMenu mr='107px'>
                    <MenuItem active={secIndex === 0 ? 1 : 0} onClick={() => handleNavigate(0)}>Token</MenuItem>
                    <MenuItem active={secIndex === 1 ? 1 : 0} onClick={() => handleNavigate(1)}>Features</MenuItem>
                    <MenuItem active={secIndex === 2 ? 1 : 0} onClick={() => handleNavigate(2)}>Roadmap</MenuItem>
                    <MenuItem onClick={() => handleNavigate(3)}>Docs</MenuItem>
                </PCMenu>
                <SocialGroup>
                    <Box onClick={() => window.open('https://twitter.com/frozenexchange', '_blank')}>
                        <img src={Social1} alt='' />
                    </Box>
                    <Box onClick={() => window.open('https://t.me/frozenexchange', '_blank')}>
                        <img src={Social2} alt='' />
                    </Box>
                    <Box onClick={() => window.open('https://www.reddit.com/user/frozenexchange', '_blank')}>
                        <img src={Social3} alt='' />
                    </Box>
                    <Box onClick={() => window.open('https://medium.com/@frozenexchange', '_blank')}>
                        <img src={Social4} alt='' />
                    </Box>
                </SocialGroup>
                <MenuIcon onClick={() => setOpen(!open)}>
                    <Box />
                    <Box />
                    <Box />
                </MenuIcon>
            </Box>
            <MobileMenu>
                <Collapse in={open}>
                    <Box>
                        <Box onClick={() => { handleNavigate(0); setOpen(false) }}>Token</Box>
                        <Box onClick={() => { handleNavigate(1); setOpen(false) }}>Features</Box>
                        <Box onClick={() => { handleNavigate(2); setOpen(false) }}>Roadmap</Box>
                        <Box onClick={() => { handleNavigate(3); setOpen(false) }}>Docs</Box>
                    </Box>
                </Collapse>
            </MobileMenu>
        </StyledContainer>
    );
}

const MobileMenu = styled(Box)`
    position: absolute;
    top: calc(100% - 1px);
    left: 0;
    width: 100%;
    background-color: #e1edf7;
    z-index:2;
    >div >div >div{
        color: #7BA4D2;
        display: flex;
        justify-content: center;
        font-size: 24px;
        cursor: pointer;
        >div {
            text-align: center;
            >div {
                padding: 8px;
            }
        }
    }
    >div >div+div {
        margin-top: 16px;
    }
    @media (min-width: 1024px) {
        display: none;
    }
`

const MenuIcon = styled(Box)`
    cursor: pointer;
    @media (min-width: 1024px) {
        display: none;
    }
    >div {
        width: 27.16px;
        height: 2px;
        background: #7BA4D2;
    }
    >div+div {
        margin-top: 8.3px;
    }
`

const SocialGroup = styled(Box)`
    display: flex;
    >div {
        cursor: pointer;
    }
    >div+div {
        margin-left: 16px;
    }
    @media (max-width: 1024px) {
        display: none;
    }
`

const MenuItem = styled(Box) <any>`
    cursor: pointer;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: ${({ active }) => active ? '#3F78BD' : '#757575'};
`

const PCMenu = styled(Box)`
    display: flex;
    align-items: center;
    >div+div {
        margin-left: 24px;
    }
    @media (max-width: 1024px) {
        display: none;
    }
`

const StyledContainer = styled(Box)`
    z-index: 99;
    width: 100%;
    /* background: #e1edf7; */
    background: rgba(255, 255, 255, 0.53);
    height: 52px;
    padding-left: 17px;
    padding-right: 20.84px;
    @media (min-width: 1024px) {
        padding-left: 29.82px;
        padding-right: 79px;
        height: 71px;
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    >div:first-of-type >img {
        cursor: pointer;
        pointer-events: initial;
        height: 32px;
        @media (min-width: 1024px) {
            height: auto !important;
        }
    }
`

export default Topbar;